export const GET_EDOK_FORM_BY_MODULE_FAILURE = 'GET_EDOK_FORM_BY_MODULE_FAILURE';

export const getEdokFormByModuleFailure = error => ({
    type: GET_EDOK_FORM_BY_MODULE_FAILURE,
    payload: error,
    error: true,
});
